export default "__VITE_ASSET__DkKNv6_C__"